import React from 'react';
/*
1. HoneyIcon
2. CheeseIcon
3. FishIcon
4. PastryIcon
5. VegetablesIcon
6. ArrowRight
7. CoffeeCup
*/

export const HoneyIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25.517"
			height="27.17"
			viewBox="0 0 25.517 27.17"
		>
			<g transform="translate(0.26 0.25)">
				<path
					d="M24.884,7.63,22.746,5.492a1.633,1.633,0,0,0-.773-.435A1.221,1.221,0,0,0,21.9,3.942,1.226,1.226,0,0,0,22.493,2.9V1.225A1.227,1.227,0,0,0,21.268,0H3.73A1.227,1.227,0,0,0,2.5,1.225V2.9a1.226,1.226,0,0,0,.588,1.047,1.222,1.222,0,0,0-.068,1.114,1.633,1.633,0,0,0-.773.435L.113,7.63A.391.391,0,0,0,.389,8.3a3.141,3.141,0,0,1,.873.109A5.839,5.839,0,0,0,.553,12.8l2.91,12.285A2.054,2.054,0,0,0,5.468,26.67H19.529a2.054,2.054,0,0,0,2.005-1.586L24.444,12.8a5.84,5.84,0,0,0-.709-4.393,3.148,3.148,0,0,1,.873-.109.39.39,0,0,0,.276-.667Zm-21.6-6.4A.445.445,0,0,1,3.73.781H21.268a.445.445,0,0,1,.444.444V2.9c0,.245-.418,1.425-.418,1.67a.445.445,0,0,1-.444.444H4.148A.445.445,0,0,1,3.7,4.566c0-.245-.418-1.425-.418-1.67Zm20.4,11.394L20.774,24.9a1.275,1.275,0,0,1-1.245.985H5.468A1.275,1.275,0,0,1,4.223,24.9L1.314,12.619A5.055,5.055,0,0,1,1.981,8.73c.073.043.145.088.22.134a3.73,3.73,0,0,0,2.223.685,3.731,3.731,0,0,0,2.224-.685A2.953,2.953,0,0,1,8.459,8.3a2.954,2.954,0,0,1,1.812.568A3.733,3.733,0,0,0,12.5,9.55a3.731,3.731,0,0,0,2.224-.685,3.177,3.177,0,0,1,3.625,0,3.956,3.956,0,0,0,4.45,0c.074-.046.148-.091.221-.135a5.055,5.055,0,0,1,.668,3.889ZM22.383,8.2a3.179,3.179,0,0,1-3.626,0,3.954,3.954,0,0,0-4.449,0,2.953,2.953,0,0,1-1.812.568A2.955,2.955,0,0,1,10.684,8.2a3.733,3.733,0,0,0-2.224-.685A3.732,3.732,0,0,0,6.235,8.2a2.953,2.953,0,0,1-1.812.567A2.952,2.952,0,0,1,2.613,8.2a3.981,3.981,0,0,0-1.364-.6L2.8,6.044a.857.857,0,0,1,.61-.253h2.5l-.629.961a.391.391,0,1,0,.654.428l.909-1.389h8.717l.23.545a.391.391,0,0,0,.72-.3l-.1-.24h5.173a.856.856,0,0,1,.609.253L23.748,7.6a3.994,3.994,0,0,0-1.366.6Zm0,0"
					transform="translate(0)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.5"
				/>
				<path
					d="M109.282,464.938H96.545a.393.393,0,0,0,0,.781h12.737a.393.393,0,0,0,0-.781Zm0,0"
					transform="translate(-90.415 -442.72)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.5"
				/>
			</g>
		</svg>
	);
};

export const CheeseIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28.2"
			height="21.677"
			viewBox="0 0 28.2 21.677"
		>
			<g transform="translate(0.1 -24.75)">
				<g transform="translate(5.711 36.094)">
					<g data-name="Group 4062" transform="translate(0 0)">
						<path
							d="M45.928,110.52a2.337,2.337,0,1,0,2.413,2.336A2.378,2.378,0,0,0,45.928,110.52Zm0,3.785a1.452,1.452,0,1,1,1.527-1.449A1.491,1.491,0,0,1,45.928,114.305Z"
							transform="translate(-43.515 -110.52)"
							fill="#292929"
							stroke="#292929"
							strokeWidth="0.2"
						/>
					</g>
				</g>
				<g transform="translate(10.895 28.422)">
					<g transform="translate(0 0)">
						<path
							d="M85.166,52.066c-1.207,0-2.153.73-2.153,1.661s.946,1.661,2.153,1.661,2.153-.73,2.153-1.661S86.374,52.066,85.166,52.066Zm0,2.437c-.675,0-1.267-.362-1.267-.776,0-.367.521-.775,1.267-.775s1.267.409,1.267.775C86.434,54.14,85.842,54.5,85.166,54.5Z"
							transform="translate(-83.013 -52.066)"
							fill="#292929"
							stroke="#292929"
							strokeWidth="0.2"
						/>
					</g>
				</g>
				<g transform="translate(5.711 36.094)">
					<g transform="translate(0 0)">
						<path
							d="M45.928,110.52a2.337,2.337,0,1,0,2.413,2.336A2.378,2.378,0,0,0,45.928,110.52Zm0,3.785a1.452,1.452,0,1,1,1.527-1.449A1.491,1.491,0,0,1,45.928,114.305Z"
							transform="translate(-43.515 -110.52)"
							fill="#292929"
							stroke="#292929"
							strokeWidth="0.2"
						/>
					</g>
				</g>
				<g transform="translate(0 24.85)">
					<g transform="translate(0 0)">
						<path
							d="M27.79,31.511a2.64,2.64,0,0,0-.513-.806,18.4,18.4,0,0,0-8.2-5.049,19.1,19.1,0,0,0-5.47-.806,1.441,1.441,0,0,0-.942.313c-.107.092-5.706,4.845-6.811,5.781a.99.99,0,0,0-.3.4.443.443,0,0,0,.245.56c.324.135.493.356.493.53s-.177.371-.512.5a2.249,2.249,0,0,1-.82.147,2.312,2.312,0,0,1-.72-.111,1.2,1.2,0,0,0-.354-.077.955.955,0,0,0-.62.255c-.037.031-.144.119-.293.241-1.137.929-1.935,1.6-2.14,1.835a4.363,4.363,0,0,0-.446.609A2.244,2.244,0,0,0,0,37.162v2.283a.606.606,0,0,0,.612.667A.974.974,0,0,0,.758,40.1l.017,0a.616.616,0,0,1,.093-.007.8.8,0,0,1,0,1.6.726.726,0,0,1-.083,0A.657.657,0,0,0,.7,41.682a.681.681,0,0,0-.7.676v3.175a.773.773,0,0,0,.787.794.962.962,0,0,0,.161-.014c.331-.057,11.715-1.977,19.248-3.248l7.075-1.194a.728.728,0,0,0,.669-.794c0-.025,0-.275.006-.677.015-1.667.055-6.1.055-7.868A3.016,3.016,0,0,0,27.79,31.511ZM3.536,34.082c.156-.127.267-.219.306-.252a.2.2,0,0,1,.12-.012,3.208,3.208,0,0,0,1,.156,3.143,3.143,0,0,0,1.147-.21,1.534,1.534,0,0,0,1.11-1.348,1.27,1.27,0,0,0-.453-.939c-.027-.024-.074-.078-.007-.135,1.532-1.3,6.37-5.4,6.488-5.506a.588.588,0,0,1,.365-.1,17.806,17.806,0,0,1,13.022,5.578l.025.027-.4.069L18.491,32.7a2.591,2.591,0,0,0-1.422-.418,2.687,2.687,0,0,0-.335.021,2.109,2.109,0,0,0-1.745.978L1.9,35.448C2.395,35.015,3.208,34.35,3.536,34.082ZM18.1,33.507a.928.928,0,0,1,.365.723,1.4,1.4,0,0,1-2.795,0,1.111,1.111,0,0,1,.057-.423c.084-.265.277-.524,1.118-.629a1.829,1.829,0,0,1,.225-.014,1.646,1.646,0,0,1,1.03.342h0Zm8.961,6.886c0,.3,0,.513-.006.617l-7.005,1.182C12.383,43.485,2,45.237.886,45.425V42.579a1.689,1.689,0,0,0,0-3.374V36.926c0-.317.082-.354.319-.435L14.783,34.21v.021a2.284,2.284,0,0,0,4.567,0,1.636,1.636,0,0,0-.168-.75l7.216-1.2.672-.106a1.667,1.667,0,0,1,.045.355C27.115,34.3,27.074,38.727,27.059,40.393Z"
							transform="translate(0 -24.85)"
							fill="#292929"
							stroke="#292929"
							strokeWidth="0.2"
						/>
					</g>
				</g>
				<g transform="translate(10.895 28.422)">
					<g transform="translate(0 0)">
						<path
							d="M85.166,52.066c-1.207,0-2.153.73-2.153,1.661s.946,1.661,2.153,1.661,2.153-.73,2.153-1.661S86.374,52.066,85.166,52.066Zm0,2.437c-.675,0-1.267-.362-1.267-.776,0-.367.52-.775,1.267-.775s1.267.409,1.267.775C86.434,54.14,85.841,54.5,85.166,54.5Z"
							transform="translate(-83.013 -52.066)"
							fill="#292929"
							stroke="#292929"
							strokeWidth="0.2"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const FishIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36.945"
			height="33.668"
			viewBox="0 0 36.945 33.668"
		>
			<g transform="matrix(0.891, -0.454, 0.454, 0.891, -29.054, -43.403)">
				<g transform="translate(0 63.998)">
					<g id="Group_4060" data-name="Group 4060" transform="translate(0 0)">
						<path
							d="M29.921,75.568A14.672,14.672,0,0,0,18.5,67.854C16.086,64.8,8.512,64.033,8.185,64a.625.625,0,0,0-.643.847,50.391,50.391,0,0,1,1.7,5.017,21.245,21.245,0,0,0-3.353,1.856C4.213,69.031.782,69,.625,69A.625.625,0,0,0,0,69.623c0,3.621,1.262,5.439,2.106,6.25C1.262,76.684,0,78.5,0,82.123a.625.625,0,0,0,.625.625c.157,0,3.588-.034,5.269-2.723a24.442,24.442,0,0,0,4.755,2.457A6.645,6.645,0,0,0,10,85.873a.625.625,0,0,0,.625.625c.186,0,4.436-.037,6.553-2.52a14.653,14.653,0,0,0,12.743-7.8A.625.625,0,0,0,29.921,75.568ZM9.077,65.37c2.1.3,5.548,1.052,7.5,2.391a19.787,19.787,0,0,0-6.167,1.6C10.129,68.264,9.516,66.547,9.077,65.37Zm2.188,19.842c.083-1.739.484-2.183.6-2.274a20.336,20.336,0,0,0,3.572.938A9.051,9.051,0,0,1,11.265,85.212Zm.524-2.3v0l.005,0Zm5.086-.167c-3.652,0-9.624-3-10.73-4.13A.624.624,0,0,0,5.7,78.43a.659.659,0,0,0-.114.01.625.625,0,0,0-.46.367,4.771,4.771,0,0,1-3.858,2.636c.2-3.917,2.049-4.963,2.144-5.014a.628.628,0,0,0,0-1.111c-.084-.045-1.948-1.084-2.145-5.011a4.806,4.806,0,0,1,3.858,2.632.625.625,0,0,0,1.021.189C7.251,72,13.223,69,16.875,69a13.409,13.409,0,0,1,11.78,6.875A13.409,13.409,0,0,1,16.875,82.748Z"
							transform="translate(0 -63.998)"
							fill="#292929"
						/>
						<path
							d="M299.917,176.306a9.143,9.143,0,0,1,1.146-4.655.625.625,0,0,0-1.041-.692,11.226,11.226,0,0,0,0,10.693.625.625,0,1,0,1.04-.693A9.022,9.022,0,0,1,299.917,176.306Z"
							transform="translate(-281.167 -164.431)"
							fill="#292929"
						/>
						<path
							d="M258.219,170.786a.626.626,0,0,0-.864.174A10.2,10.2,0,0,0,256,176.307a11.387,11.387,0,0,0,.694,3.97.625.625,0,0,0,1.171-.438,10.139,10.139,0,0,1-.615-3.532,9.143,9.143,0,0,1,1.146-4.655A.626.626,0,0,0,258.219,170.786Z"
							transform="translate(-241 -164.432)"
							fill="#292929"
						/>
						<circle
							cx="1.25"
							cy="1.25"
							r="1.25"
							transform="translate(21.25 8.75)"
							fill="#292929"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const PastryIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30.4"
			height="22.08"
			viewBox="0 0 30.4 22.08"
		>
			<g transform="translate(0.2 -70.8)">
				<path
					d="M241.879,131a.879.879,0,0,0-.879.879v2.344a.879.879,0,0,0,1.758,0v-2.344A.879.879,0,0,0,241.879,131Z"
					transform="translate(-226.879 -56.484)"
					fill="#292929"
					stroke="#fff"
					strokeWidth="0.4"
				/>
				<path
					d="M292.608,131.39a.879.879,0,1,0-1.463.975l1.172,1.758a.879.879,0,0,0,1.463-.975Z"
					transform="translate(-273.947 -56.483)"
					fill="#292929"
					stroke="#fff"
					strokeWidth="0.4"
				/>
				<path
					d="M173.536,131.146a.879.879,0,0,0-1.219.244l-1.172,1.758a.879.879,0,1,0,1.463.975l1.172-1.758A.879.879,0,0,0,173.536,131.146Z"
					transform="translate(-160.978 -56.483)"
					fill="#292929"
					stroke="#fff"
					strokeWidth="0.4"
				/>
				<path
					d="M30,82.426a3.228,3.228,0,0,0-2.388-3.113,8.271,8.271,0,0,0-3.795-5.753A15.545,15.545,0,0,0,15,71a15.545,15.545,0,0,0-8.817,2.56,8.271,8.271,0,0,0-3.795,5.753,3.223,3.223,0,0,0,.191,6.271l1.053,4.211A3.8,3.8,0,0,0,7.327,92.68H22.673a3.8,3.8,0,0,0,3.695-2.885l1.053-4.211A3.228,3.228,0,0,0,30,82.426ZM5.337,89.369l-.93-3.72H8.365l.659,5.273h-1.7a2.048,2.048,0,0,1-1.99-1.553Zm14.527-3.72L19.2,90.922H15.879V85.648Zm-5.743,5.273H10.8l-.659-5.273h3.985Zm10.542-1.553a2.048,2.048,0,0,1-1.99,1.553h-1.7l.659-5.273h3.958Zm2.114-5.478H3.223a1.465,1.465,0,0,1,0-2.93.879.879,0,0,0,.879-.879A6.329,6.329,0,0,1,7.186,75,13.779,13.779,0,0,1,15,72.758,13.779,13.779,0,0,1,22.814,75,6.329,6.329,0,0,1,25.9,80.082a.879.879,0,0,0,.879.879,1.465,1.465,0,0,1,0,2.93Z"
					fill="#292929"
					stroke="#fff"
					strokeWidth="0.4"
				/>
			</g>
		</svg>
	);
};

export const VegetablesIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30.266"
			height="30.213"
			viewBox="0 0 30.266 30.213"
		>
			<g transform="translate(-29.848 -79.885)">
				<path
					d="M30.959,12.163a2.017,2.017,0,0,0-.911-1.333,6.882,6.882,0,0,0-.717-.4,2.308,2.308,0,0,0,1.636-2.5,1.915,1.915,0,0,0-.807-1.305c-.05-.035-.106-.057-.159-.087,0-.006,0-.013,0-.019a1.915,1.915,0,0,0-.807-1.305,2.018,2.018,0,0,0-1.586-.3,6.78,6.78,0,0,0-.737.2,6.78,6.78,0,0,0,.2-.737,2.015,2.015,0,0,0-.3-1.586,1.917,1.917,0,0,0-1.307-.807h-.018a1.8,1.8,0,0,0-.087-.159,1.915,1.915,0,0,0-1.306-.807,2.307,2.307,0,0,0-2.5,1.637,6.881,6.881,0,0,0-.4-.717,2.017,2.017,0,0,0-1.333-.911,1.916,1.916,0,0,0-1.493.353,2.317,2.317,0,0,0-.457,3.182,11.751,11.751,0,0,1,1.183,2.044l.1.224a6.6,6.6,0,0,0-5.318,1.919,6.67,6.67,0,0,0-.913,1.139L1.267,28.286A1.764,1.764,0,0,0,3.7,30.723L22.1,19.058a6.648,6.648,0,0,0,3.057-6.231l.225.1a11.775,11.775,0,0,1,2.044,1.184,2.313,2.313,0,0,0,1.358.434,2.256,2.256,0,0,0,1.823-.892,1.912,1.912,0,0,0,.353-1.492Zm-2.072-2.61a12.464,12.464,0,0,0-1.322.288A7.316,7.316,0,0,0,25.1,9.79L25.02,9.8l.1-.133a6.253,6.253,0,0,1,3.658-2.392,1.056,1.056,0,0,1,.834.148.961.961,0,0,1,.4.655,1.354,1.354,0,0,1-1.123,1.473ZM27.808,5.866a1.055,1.055,0,0,1,.834.148.937.937,0,0,1,.264.279,2.186,2.186,0,0,0-.333.038A7.136,7.136,0,0,0,24.339,9.1l-.672.911-1.176.178,3.721-3.721a5.937,5.937,0,0,1,1.6-.6ZM25.659,3.418a2.128,2.128,0,0,0,.039-.333.928.928,0,0,1,.279.264,1.061,1.061,0,0,1,.148.834,5.952,5.952,0,0,1-.6,1.6L21.807,9.5l.178-1.176.911-.672a7.138,7.138,0,0,0,2.763-4.234ZM22.437,3.1A1.357,1.357,0,0,1,23.91,1.981a.962.962,0,0,1,.655.4,1.061,1.061,0,0,1,.148.834,6.259,6.259,0,0,1-2.392,3.658l-.133.1.012-.079a7.294,7.294,0,0,0-.051-2.467A12.628,12.628,0,0,0,22.437,3.1ZM18.661,4a1.353,1.353,0,0,1,.247-1.836.975.975,0,0,1,.578-.195.942.942,0,0,1,.168.015,1.059,1.059,0,0,1,.695.485,6.257,6.257,0,0,1,.9,4.279L20.979,8.5l-1.036-2.29A12.773,12.773,0,0,0,18.661,4Zm3.892,13.462a5.691,5.691,0,0,1-.973.779L3.185,29.906a.8.8,0,0,1-1.1-1.1L13.748,10.411a5.728,5.728,0,0,1,.782-.976A5.636,5.636,0,0,1,19.639,7.89l1.132,2.5a.491.491,0,0,0,.1.14l0,0,.585.585h0a.468.468,0,0,0,.141.1l2.5,1.132A5.632,5.632,0,0,1,22.553,17.462Zm7.274-4.379a1.355,1.355,0,0,1-1.835.248,12.747,12.747,0,0,0-2.213-1.282l-2.29-1.036,1.755-.265a6.25,6.25,0,0,1,4.279.9,1.06,1.06,0,0,1,.485.695.961.961,0,0,1-.18.745Z"
					transform="translate(29.01 78.998)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.2"
				/>
				<path
					d="M31.083,25.118a4.353,4.353,0,0,1-1.283-3.1V22l-.8.02A5.181,5.181,0,0,0,34.2,27.2l-.02-.8A4.352,4.352,0,0,1,31.083,25.118Z"
					transform="translate(14.467 69.33)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.2"
				/>
				<path
					d="M25.814,31.449A3.441,3.441,0,0,1,24.8,29H24a4.235,4.235,0,0,0,1.249,3.015l.138.138A4.235,4.235,0,0,0,28.4,33.4v-.8a3.441,3.441,0,0,1-2.449-1.014Z"
					transform="translate(17.466 65.131)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.2"
				/>
				<path
					d="M20.683,37.318a3,3,0,0,1-.883-2.132V35H19v.186A3.815,3.815,0,0,0,22.815,39H23v-.8h-.186A3,3,0,0,1,20.683,37.318Z"
					transform="translate(20.466 61.532)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.2"
				/>
				<path
					d="M15.083,45.317a.96.96,0,0,1-.283-.683V44H14v.635A1.766,1.766,0,0,0,15.766,46.4H16.4v-.8h-.635a.96.96,0,0,1-.683-.283Z"
					transform="translate(23.465 56.132)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.2"
				/>
			</g>
		</svg>
	);
};

export const ArrowRight = () => {
	return (
		<svg width="15.394" height="10" viewBox="0 0 15.394 10">
			<path
				d="M13.674,6.343,12.427,7.6l2.89,2.877-12.025.012,0,1.768,11.992-.012L12.444,15.1,13.7,16.343l4.988-5.012Z"
				transform="translate(-3.292 -6.343)"
			/>
		</svg>
	);
};

export const ArrowRightWhite = () => {
	return (
		<svg width="15.394" height="10" viewBox="0 0 15.394 10">
			<path
				d="M13.674,6.343,12.427,7.6l2.89,2.877-12.025.012,0,1.768,11.992-.012L12.444,15.1,13.7,16.343l4.988-5.012Z"
				transform="translate(-3.292 -6.343)"
				fill="#FFF"
				stroke="#FFF"				
			/>
		</svg>
	);
};

export const Whatsapp = () => {
	return (
		<svg width="25" height="25" viewBox="0 0 25 25" >
			<path
				d=" M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z"
				transform="translate(-5 -5)"
				fill="#FFF"
				stroke="#FFF"					
			/>
		</svg>
	);
};

export const SandwichIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30"
			height="17.578"
			viewBox="0 0 30 17.578"
		>
			<g id="sandwich" transform="translate(0.001 -0.001)">
				<path
					id="Path_17393"
					data-name="Path 17393"
					d="M28.827,11.82v-2.6a1.712,1.712,0,0,0,1-1.941C28.579,1.918,20.514,0,15,0A25.832,25.832,0,0,0,6.637,1.381a.586.586,0,1,0,.395,1.1c.1-.036.2-.071.3-.106L8.1,4.491a1.758,1.758,0,0,0,3.3-1.2l-.639-1.757c.664-.112,1.34-.2,2.023-.259l1.172,3.219a1.758,1.758,0,1,0,3.3-1.2l-.753-2.068c.733.045,1.47.122,2.2.231l1.107,3.04a1.758,1.758,0,1,0,3.3-1.2l-.312-.855c2.274.8,5.227,2.344,5.872,5.113A.574.574,0,0,1,28.1,8.2H1.9a.574.574,0,0,1-.585-.658,5.559,5.559,0,0,1,1.835-2.9.586.586,0,1,0-.775-.879A6.7,6.7,0,0,0,.17,7.28a1.712,1.712,0,0,0,1,1.941v2.6A1.761,1.761,0,0,0,0,13.477a4.106,4.106,0,0,0,4.1,4.1H25.9a4.106,4.106,0,0,0,4.1-4.1,1.761,1.761,0,0,0-1.172-1.657ZM9.957,4.441a.587.587,0,0,1-.751-.35L8.458,2.037c.373-.1.756-.2,1.145-.281l.7,1.933a.588.588,0,0,1-.35.752Zm5.859,0a.587.587,0,0,1-.751-.351l-1.055-2.9c.334-.014.665-.022.989-.022l.252,0,.916,2.515a.588.588,0,0,1-.35.752Zm5.859,0a.587.587,0,0,1-.751-.35l-.876-2.407c.465.094.92.2,1.363.319l.615,1.687a.588.588,0,0,1-.35.752ZM21.1,11.719l2.344-2.344h4.21v2.344Zm-8.446,2.1L8.211,9.376H17.1ZM2.343,9.376h4.21L8.9,11.719H2.343Zm16.415,0h3.03L17.343,13.82l-1.515-1.515Zm7.14,7.031H4.1a2.933,2.933,0,0,1-2.93-2.93.586.586,0,0,1,.586-.586h8.312l2.172,2.172a.586.586,0,0,0,.829,0L15,13.134l1.929,1.929a.586.586,0,0,0,.829,0l2.172-2.172h8.312a.586.586,0,0,1,.586.586,2.933,2.933,0,0,1-2.93,2.93Zm0,0"
					fill="#292929"
				/>
				<path
					id="Path_17394"
					data-name="Path 17394"
					d="M71.172,39.586a.586.586,0,1,0-.586.586A.586.586,0,0,0,71.172,39.586Zm0,0"
					transform="translate(-65.899 -36.714)"
					fill="#292929"
				/>
			</g>
		</svg>
	);
};

export const CoffeeCup = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30"
			height="26.25"
			viewBox="0 0 30 26.25"
		>
			<g transform="translate(0 -32.001)">
				<g transform="translate(3.749 42)">
					<g transform="translate(0 0)">
						<path
							d="M83.364,202.654h-17.5a1.877,1.877,0,0,0-1.875,1.875v1.25a11.846,11.846,0,0,0,6.429,10.556.625.625,0,1,0,.574-1.111,10.6,10.6,0,0,1-5.753-9.445v-1.25a.625.625,0,0,1,.625-.625h17.5a.625.625,0,0,1,.625.625v1.25a10.594,10.594,0,0,1-5.754,9.444.626.626,0,0,0,.287,1.181.616.616,0,0,0,.286-.07,11.84,11.84,0,0,0,6.43-10.555v-1.25A1.877,1.877,0,0,0,83.364,202.654Z"
							transform="translate(-63.988 -202.654)"
							fill="#292929"
						/>
					</g>
				</g>
				<g transform="translate(0 54.499)">
					<g transform="translate(0 0)">
						<path
							d="M28.7,416.352a.626.626,0,0,0-.578-.386H.625a.626.626,0,0,0-.443,1.068l1.4,1.4a4.349,4.349,0,0,0,3.094,1.281H24.071a4.357,4.357,0,0,0,3.1-1.281l1.4-1.4A.624.624,0,0,0,28.7,416.352Zm-2.421,1.2a3.107,3.107,0,0,1-2.21.915H4.678a3.107,3.107,0,0,1-2.21-.915l-.335-.335H26.617Z"
							transform="translate(0 -415.966)"
							fill="#292929"
						/>
					</g>
				</g>
				<g transform="translate(20.807 44.497)">
					<g>
						<path
							d="M363.078,245.726c-1.684-1.083-4.374.093-4.675.229a.626.626,0,0,0,.519,1.139c.6-.274,2.535-.923,3.48-.314a1.776,1.776,0,0,1,.635,1.62c0,2.5-5.048,4.015-7,4.388l-.443.087a.625.625,0,0,0,.12,1.238.58.58,0,0,0,.121-.012l.439-.086c.328-.063,8.009-1.569,8.009-5.614A2.948,2.948,0,0,0,363.078,245.726Z"
							transform="translate(-355.093 -245.272)"
							fill="#292929"
						/>
					</g>
				</g>
				<g transform="translate(17.5 32.001)">
					<g transform="translate(0 0)">
						<path
							d="M300.407,36.765a3.745,3.745,0,0,0,0-4.529.625.625,0,0,0-.976.781,2.521,2.521,0,0,1,0,2.969,3.741,3.741,0,0,0,0,4.529.625.625,0,1,0,.976-.781A2.517,2.517,0,0,1,300.407,36.765Z"
							transform="translate(-298.666 -32.001)"
							fill="#292929"
						/>
					</g>
				</g>
				<g transform="translate(13.746 32.001)">
					<g transform="translate(0 0)">
						<path
							d="M236.337,36.773a3.741,3.741,0,0,0,0-4.529.625.625,0,1,0-.976.781,2.517,2.517,0,0,1,0,2.969,3.745,3.745,0,0,0,0,4.529.625.625,0,0,0,.976-.781A2.521,2.521,0,0,1,236.337,36.773Z"
							transform="translate(-234.597 -32.009)"
							fill="#292929"
						/>
					</g>
				</g>
				<g transform="translate(10 32.002)">
					<g transform="translate(0 0)">
						<path
							d="M172.407,36.786a3.745,3.745,0,0,0,0-4.529.625.625,0,0,0-.976.78,2.521,2.521,0,0,1,0,2.969,3.741,3.741,0,0,0,0,4.529.625.625,0,1,0,.976-.78A2.518,2.518,0,0,1,172.407,36.786Z"
							transform="translate(-170.666 -32.022)"
							fill="#292929"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const DairyIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20.4"
			height="26.487"
			viewBox="0 0 20.4 26.487"
		>
			<g id="Outline" transform="translate(-71.8 -15.8)">
				<path
					d="M72.869,39.913V29.478a10.1,10.1,0,0,1,.821-4l.9-2.09c.076-.178.149-.361.217-.546a8.229,8.229,0,0,1,3.227.065,8.994,8.994,0,0,0,3.4.1c.049.127.1.254.154.38l.9,2.09.8-.342-.9-2.09c-.1-.223-.183-.449-.261-.673a10.139,10.139,0,0,1-.551-2.893H82a.435.435,0,0,0,.435-.435V17.3a1.306,1.306,0,0,0-1.3-1.3H75.043a1.306,1.306,0,0,0-1.3,1.3v1.739a.435.435,0,0,0,.435.435H74.6a10.14,10.14,0,0,1-.534,2.842c-.084.246-.178.489-.278.724l-.9,2.09A10.964,10.964,0,0,0,72,29.478V39.913a2.176,2.176,0,0,0,2.174,2.174H81.13v-.87H74.174A1.306,1.306,0,0,1,72.869,39.913ZM74.609,17.3a.435.435,0,0,1,.435-.435H81.13a.435.435,0,0,1,.435.435v1.3H74.609Zm6.1,2.174a10.993,10.993,0,0,0,.445,2.692,8.129,8.129,0,0,1-2.929-.113,9.1,9.1,0,0,0-3.122-.14,11,11,0,0,0,.373-2.439Z"
					transform="translate(0 0)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.4"
				/>
				<path
					d="M243.3,202.174c0-1.427-2.843-2.174-5.652-2.174s-5.652.747-5.652,2.174a1.043,1.043,0,0,0,.012.157l1.294,13.365a.435.435,0,0,0,.433.391h7.826A.435.435,0,0,0,242,215.7l1.294-13.365A1.047,1.047,0,0,0,243.3,202.174Zm-1.185,3.56-.22.073a6.893,6.893,0,0,1-4.181.063,7.786,7.786,0,0,0-4.48,0l-.039.012-.214-2.428a12.643,12.643,0,0,0,9.336,0Zm-4.467-4.864c3.075,0,4.76.851,4.782,1.3l0,.054c-.108.453-1.785,1.259-4.777,1.259s-4.668-.805-4.777-1.259l0-.054C232.892,201.72,234.577,200.87,237.652,200.87Zm3.52,14.348h-7.04l-.851-8.452.207-.062a6.947,6.947,0,0,1,3.981,0,7.754,7.754,0,0,0,4.559-.024Z"
					transform="translate(-151.304 -174)"
					fill="#292929"
					stroke="#292929"
					strokeWidth="0.4"
				/>
			</g>
		</svg>
	);
};
